import log from 'loglevel';

// Set the default log level
log.setLevel('info'); // You can adjust this based on your needs

// Custom logger functions for different log levels
const logTrace = (message) => {
  log.trace(message);
};

const logDebug = (message) => {
  log.debug(message);
};

const logInfo = (message) => {
  log.info(message);
};

const logWarn = (message) => {
  log.warn(message);
};

const logError = (message) => {
  log.error(message);
};

// Export the logger functions
export { logTrace, logDebug, logInfo, logWarn, logError };
